import { getInvitePropertyPerUserAction } from 'store/actions/inviteActions';
import { getUserBuildingAction } from 'store/actions/userActions';

export const ACCEPTER_ROLE_TO_USER_ROUTE = {
  vp: 'full-portfolio',
  rm: 'multi-site',
  pm: 'property',
};

export const resolveUserDelegationRoute = (accepterRole) =>
  ACCEPTER_ROLE_TO_USER_ROUTE[accepterRole] ?? null;

export const preloadUserDelegationContext = (dispatch, user) => {
  if (!user) return;
  if (user.property) {
    dispatch(getUserBuildingAction({ id: user.property }));
  }
  dispatch(
    getInvitePropertyPerUserAction({
      accepter_id: user.accepter_id,
      accepter_role: user.accepter_role,
      requestor_id: user.requestor_id,
      requestor_role: user.requestor_role,
      landlord_id: user.landlord_id,
    }),
  );
};
